import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  display: flex;
  position: absolute;
  overflow-y: auto;
  width: 343px;
  height: auto;
  padding: 0 1em;
  top: 11em;
  right: 10em;
  z-index: 2;
  .MuiInput-underline:before {
    border: none;
  }
  #comment-title,
  #comment-description {
    color: rgba(0, 0, 0, 0.87);
    font-family: ${({ theme }) => theme.font.primary};
    font-size: 0.875rem;
  }
  #comment-title {
    font-weight: 700;
  }
  #comment-description {
    font-weight: 400;
  }
`;

export const ButtonApproval = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: ${({ addCommentStyle }) =>
    addCommentStyle ? "space-around" : "center"};
  align-items: center;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  background-color: ${({ active }) =>
    active ? theme.primary.purple : "transparent"};
  border-radius: 4px;
  margin-top: 1em;
  margin-right: 4.5em;
  margin-bottom: 1em;
  color: ${({ active }) =>
    active ? theme.neutral.white : theme.primary.purple};
  opacity: ${({ isNotDisabled }) => (!isNotDisabled ? "0.4" : "1")};
  cursor: pointer;
  width: ${({ addCommentStyle }) => (addCommentStyle ? "10em" : "9em")};
  height: 3.16em;
  font-size: 13px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleOpacity};
    transform: translateY(-1px);
  }
`;

export const NewComment = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ bgState }) => (bgState ? theme.neutral.white : theme.neutral.gray[500])};
`;

export const ContentTitleComment = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 1em 0px 0.5em 0px;
`;

export const ContentComment = styled.div`
  display: flex;
  margin: 0px 1.5em;
`;

export const ContentBtnCmmt = styled.div`
  display: flex;
  margin: 0.5em;
  justify-content: space-between;
`;

export const ContentRightBtnCmmt = styled.div`
  display: flex;
  color: ${({ theme }) => theme.neutral.black};
`;

export const ContentLeftBtnCmmt = styled.div`
  display: flex;
  color: ${({ theme }) => theme.neutral.black};
`;

export const LinkSaveEditCmmt = styled.a`
  color: ${({ theme }) => theme.neutral.black};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.neutral.black};
  }
`;

export const LinkCancelCmmt = styled.a`
  color: ${({ theme }) => theme.neutral.black};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.neutral.black};
  }
`;

export const useStyles = makeStyles(() => ({
  delete: {
    cursor: "pointer",
    "&:hover": {
      boxShadow: `0px 4px 20px 0px ${theme.primary.purple}`,
      transform: "translateY(-1px)",
      cursor: "pointer",
    },
  },
}));
